// extracted by mini-css-extract-plugin
export default {"wrapper":"CustomSwitch_wrapper__D+DUb","checked":"CustomSwitch_checked__QCdfg"};